export const weeklyScheduleApiCacheKeys = {
  fetchAll: (params = {}) => ['weeklySchedules', params],
  fetchOne: (params = {}) => ['weeklySchedule', params]
}
